import {
  DASHBOARD_LAYOUT_CELL_INSERT_DIRECTION,
  DASHBOARD_LAYOUT_ROW_ID_PARAM,
  DASHBOARD_TO_ADD_TO_PARAM,
} from '@modules/analysis/constants';
import { Direction } from '@modules/common/types';
import { EditableDashboardListItem } from '@modules/dashboard/types';

export const useDashboardToAddToFromParam = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const base64JSON = searchParams.get(DASHBOARD_TO_ADD_TO_PARAM);
  const rowID = searchParams.get(DASHBOARD_LAYOUT_ROW_ID_PARAM);
  const cellInsertDirection = searchParams.get(
    DASHBOARD_LAYOUT_CELL_INSERT_DIRECTION,
  );

  if (!base64JSON) {
    return {
      cellInsertDirection: Direction.Bottom,
    };
  }

  const decodedJSON = decodeURIComponent(window.atob(base64JSON));

  const dashboardToAddToFromParam: Pick<
    EditableDashboardListItem,
    'id' | 'viewToken' | 'editToken' | 'title' | 'metadataV2' | 'version'
  > = JSON.parse(decodedJSON);

  const getDirection = () => {
    if (cellInsertDirection === Direction.Left.toString()) {
      return Direction.Left;
    }

    if (cellInsertDirection === Direction.Top.toString()) {
      return Direction.Top;
    }

    if (cellInsertDirection === Direction.Right.toString()) {
      return Direction.Right;
    }

    return Direction.Bottom;
  };

  return {
    dashboardToAddToFromParam,
    rowID,
    cellInsertDirection: getDirection(),
  };
};
